import {  ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { AuthenticationService } from '@core/auth/authentication.service';
import { PerfilEnum } from '@core/models/perfil';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import FileSaver from 'file-saver';
import { dataComDigitacao } from '@shared/util/util';
import { UsuarioService } from '@core/services/usuario.service';
import { RelatoriosService } from '@core/services/relatorios.service';
import dayjs from 'dayjs';
import { NotificationService } from '@core/services/notification.service';
import { ColumnOrder } from '@core/table/order';

export function validarDatas(dataInicio: string, dataFim: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dataInicioValue = control.get(dataInicio)?.value;
    const dataFimValue = control.get(dataFim)?.value;

    if (dataInicioValue && dataFimValue) {
      const dataInicio = dayjs(dataInicioValue);
      const dataFim = dayjs(dataFimValue);

      if (dataInicio.isAfter(dataFim)) {
        return { dataInicioMaiorQueDataFim: true };
      }
    }
    return null;
  };
}


@Component({
  selector: 'app-sessao-ativa',
  templateUrl: './sessao-ativa.component.html',
  styleUrl: './sessao-ativa.component.scss'
})
export class SessaoAtivaComponent {
size: NzButtonSize = 'large';
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  sessaoAtivaForm!: FormGroup;
  usuarioList: any[] = [];
  tipoArquivoList: any[] = [];
  origemArquivoList: any[] = [];
  origemConsultasMailingList: any[] = [];
  dataSet: any;
  filtro: any;

  columOrder: ColumnOrder | undefined;

  columnsLista: string[] = [
    'Nome', 'E-mail', 'Login', 'Data do Acesso', 'Data da Expiraçãoo', 'Status'];
  perfilUsuarioLogado: any;
  menu!: NzDropdownMenuComponent;
  nzFilterOption = (): boolean => true;

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.pesquisar();
  }
  constructor(
    private fb: FormBuilder,
    private relatoriosService: RelatoriosService,
    private authenticationService: AuthenticationService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private notificationService: NotificationService,

  ) {}

  ngOnInit() {
    this.construirForm();
    this.carregarSelects();
  }

  ngAfterViewInit() {
    this.changeDetector.detectChanges();

    this.paginator.change.subscribe(() => this.pesquisar());
    this.pesquisar();
  }

  construirForm() {
    this.sessaoAtivaForm = this.fb.group(
      {
        usuarioId: [],
        dataInicio: [],
        dataFim: []
      },
      {
        validators: validarDatas('dataInicio', 'dataFim')
      }
    );
  }



  carregarSelects() {
    this.usuarioService.buscarTodosCombo().subscribe((data: any) => {
      this.usuarioList = data;
    });
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.sessaoAtivaForm, campo);

    this.sessaoAtivaForm.updateValueAndValidity();

    const formErrors = this.sessaoAtivaForm.errors;
    if (formErrors?.['dataInicioMaiorQueDataFim']) {
      this.notificationService.error('Erro', 'A data de início não pode ser maior que a data de fim.');

      this.sessaoAtivaForm.patchValue({
        dataInicio: null,
        dataFim: null
      });

      this.sessaoAtivaForm.updateValueAndValidity();
    }
  }





  pesquisar() {
  this.filtro = this.sessaoAtivaForm.value;
  this.paginator.reset();
  this.consultar();
  }


  consultar(reset: boolean = false) {
    const { usuarioId, dataInicio, dataFim } = this.sessaoAtivaForm.value;

    // Se for um reset, força os filtros para valores vazios
    if (reset) {
      console.log('reset');
      this.sessaoAtivaForm.patchValue({
        usuarioId: null,
        dataInicio: null,
        dataFim: null
      });
    }

    // Realiza a consulta, passando os filtros vazios ou atualizados
    this.relatoriosService.consultarSessaoAtivaSort(
      this.filtro,
      this.paginator.pagination,
      this.columOrder || {}
    ).subscribe(data => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }


  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = { sortField: itemSelected.key, sortOrder: itemSelected.value };
      this.consultar();
    }
  }

  perfilUsuario() {
    this.perfilUsuarioLogado = this.authenticationService?.currentUserValue?.perfil?.perfil;
  }

  isPerfilUsuarioLogado() {
    return [
      PerfilEnum.Administrador,
      PerfilEnum.Atualizador,
      PerfilEnum.Validador,
      PerfilEnum.Aprovador
    ].includes(this.perfilUsuarioLogado);
  }

  resetForm() {
    this.sessaoAtivaForm.reset();
    this.paginator.reset();
    this.dataSet = [];
    this.pesquisar();
  }



  downloadDocumentos() {
    this.filtro = this.sessaoAtivaForm.value;
      this.relatoriosService.downloadSessaoAtiva(this.filtro).subscribe(
        (response: any) => {
          FileSaver.saveAs(response.body, "Relatório de Sessão Ativa.xlsx");
        }
      );
    }



    compareFn(a: any, b: any): boolean {
      if (typeof a === 'number') {
        b = isNaN(Number(b)) ? b : Number(b); // Converte b para número, se possível
        return a === b;
      }

      if (typeof a === 'string') {
        b = b != null ? b.toString() : b; // Converte b para string, se não for nulo
        return a.toLowerCase() === b.toLowerCase();
      }

      if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
        b = (typeof b === 'string') ? b === 'true' : b;
        return a === b;
      }

      if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
        const sortedA = a.slice().sort((x: any, y: any) => (x.idEntidade || 0) - (y.idEntidade || 0));
        const sortedB = b.slice().sort((x: any, y: any) => (x.idEntidade || 0) - (y.idEntidade || 0));
        return sortedA.every((itemA, index) => this.compareFn(itemA, sortedB[index]));
      }

      if (a?.idEntidade !== undefined && b?.idEntidade !== undefined) {
        return a.idEntidade === b.idEntidade;
      }

      if (Array.isArray(a) && a.length && typeof b === 'number') {
        return a[0]?.idEntidade === b;
      }

      return a === b;
    }
}
